<div [attr.id]="id" class="froala-editor"></div>
